<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="录入发票" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="票据类型">
									<el-select v-model="searchForm.is_red_status" placeholder="请选择票据类型" clearable>
										<el-option v-for="item in options.id_red_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="发票编码">
									<el-input v-model="searchForm.invoice_code" placeholder="请填写发票编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="发票抬头">
									<el-input v-model="searchForm.drawer_id" placeholder="可模糊搜索发票抬头" clearable></el-input>
								</el-form-item>
								<el-form-item label="关联状态">
									<el-select v-model="searchForm.status" placeholder="请选择关联状态" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="红冲状态" v-if="searchForm.is_red_status != 1">
									<el-select v-model="searchForm.is_red" placeholder="请选择红冲状态" clearable>
										<el-option v-for="item in options.hong_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="红冲确认">
									<el-select v-model="searchForm.c_status" placeholder="请选择红冲确认" clearable>
										<el-option v-for="item in options.hong_que_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="录入类型">
									<el-select v-model="searchForm.invoice_status" placeholder="请选择录入类型" clearable>
										<el-option v-for="item in options.invoice_status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="发票类型">
									<el-select v-model="searchForm.invoice_type" placeholder="请选择发票类型" clearable>
										<el-option v-for="item in options.invoice_type_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="发票类目">
									<el-select v-model="searchForm.invoice_info" placeholder="请选择发票类目" clearable>
										<el-option v-for="item in options.invoice_info_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="录入日期">
									<el-date-picker v-model="searchForm.create_time" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
									<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/customers/customer/invoiceentry') || $parent.$parent.isAuthAction('admin/customers/customer/iseditcategory')">
								<div>
									<el-button type="primary" size="mini" @click="addInvoiceentryOpen"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/invoiceentry')">录入发票</el-button>
									<el-button type="primary" plain size="mini" @click="addInvoiceCategoryOpen"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/iseditcategory')">添加发票类目</el-button>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" :key="tableKey" style="width: 100%" row-key="id" border stripe
									ref="table" highlight-current-row v-loading="loading" @sort-change="sortChange" :height="tableHeight">
									<el-table-column fixed prop="id" label="ID" min-width="80">
									</el-table-column>
									<el-table-column prop="invoice_status_txt" label="票据类型" width="80">
										<template slot-scope="scope">
											<el-tag effect="dark" type="danger" :size="size" v-if="scope.row.is_red == 0">红冲票</el-tag>
											<el-tag effect="dark" type="success" :size="size" v-else>正式票</el-tag>
											<!-- <span v-if="scope.row.is_red == 0" style="color: #F56C6C;font-weight: bold;">红冲票</span>
											<span v-else style="color: #409EFF;font-weight: bold;">正式票</span> -->
										</template>
									</el-table-column>
									<el-table-column prop="invoice_status_txt" label="录入类型" width="80">
									</el-table-column>
									<el-table-column prop="supplier_id_txt" label="开票方" min-width="200">
									</el-table-column>
									<el-table-column label="发票信息" min-width="300">
										<template slot-scope="scope">
											<p style="font-weight: bold;">发&nbsp;票&nbsp;号&nbsp;：<el-link type="primary"
													style="font-size: 12px; text-decoration: underline;" :underline="false"
													@click="detail(scope.row)" target="_blank">{{ scope.row.invoice_code }}</el-link></p>
											<p style="font-weight: bold;">发票抬头：{{ scope.row.drawer_id_txt }}</p>
											<p style="font-weight: bold;">发&nbsp;票&nbsp;率&nbsp;：{{ scope.row.invoice_rate }}</p>
											<p style="font-weight: bold;">发票类目：{{ scope.row.invoice_info_txt }}</p>
											<p style="font-weight: bold;">票面金额：{{ scope.row.invoice_cost }}元</p>
										</template>
									</el-table-column>
									<el-table-column label="关联信息" min-width="250">
										<template slot-scope="scope">
											<template v-if="scope.row.invoice_info.length > 0">
												<p v-for="item in scope.row.invoice_info" style="font-weight: bold;">票号:{{
													item.invoice_code }} | 金额:{{ item.invoice_cost }}</p>
											</template>
											<template v-if="scope.row.is_red != 0 && scope.row.c_status == 2">
												<p style="font-weight: bold;">红冲金额：<span style="color: #F56C6C;">{{ scope.row.c_cost }}</span>
												</p>
												<p style="font-weight: bold;">发票状态：<span style="color: #F56C6C;">冻结</span></p>
											</template>
										</template>
									</el-table-column>
									<el-table-column prop="actual_invoice_cost" label="实际金额" width="150">
									</el-table-column>
									<el-table-column prop="create_time" label="录入时间" width="150">
									</el-table-column>
									<el-table-column fixed="right" prop="is_red_txt" label="红冲状态" align="center" width="80">
										<template slot-scope="scope">
											<span style="font-weight: bold;">{{ scope.row.is_red_txt }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" prop="status_txt" label="关联状态" align="center" width="80">
										<template slot-scope="scope">
											<span style="font-weight: bold;">{{ scope.row.status_txt }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" prop="uid_txt" label="录入人" align="center" width="80">
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/invoiceentryedit') || $parent.$parent.isAuthAction('admin/customers/customer/delinvoiceentry')"
										width="150">
										<template slot-scope="scope">
											<template v-if="scope.row.c_status == 1">
												<template v-if="scope.row.is_red != 0">
													<el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size"
														v-if="$parent.$parent.isAuthAction('admin/customers/customer/invoiceentryedit') && scope.row.status == 1">编辑</el-button>
													<el-button style="color:red" @click="handleTableRed(scope.row, 'submit')" type="text"
														:size="size" class="c-danger"
														v-if="$parent.$parent.isAuthAction('admin/customers/customer/addinvoicered') && scope.row.is_red != 3 && scope.row.status != 3">红冲申请</el-button>

													<el-button style="color:red" @click="handleTableDelete(scope.row)" type="text" :size="size"
														class="c-danger"
														v-if="$parent.$parent.isAuthAction('admin/customers/customer/delinvoiceentry') && scope.row.status == 1">作废</el-button>
												</template>
												<template v-else>
													<el-button style="color:red" @click="handleTableDelete(scope.row)" type="text" :size="size"
														class="c-danger"
														v-if="$parent.$parent.isAuthAction('admin/customers/customer/delinvoiceentry') && $parent.$parent.info.views.is_supper == 'ADMIN'">作废</el-button>
												</template>
											</template>
											<template v-else>
												<el-button style="color:red" @click="handleTableRed(scope.row, 'confirm')" type="text"
													:size="size" class="c-danger"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/quereninvoicered')">确认红冲</el-button>
												<el-button style="color:red" @click="handleTableQueren(scope.row, 'confirm')" type="text"
													:size="size" class="c-danger"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/quereninvoicered')">驳回红冲</el-button>
											</template>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--新建发票录入-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="50%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>新建发票录入</span>
						<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="开票方">
						<el-radio-group v-model="addForm.type" @input="changeSUpplier()">
							<el-radio :label="1">供应商</el-radio>
							<el-radio :label="3">平台</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="开票方" prop="supplier_id">
						<el-select v-model="addForm.supplier_id" placeholder="请选择收票方" clearable filterable remote reserve-keyword
							:remote-method="(query) => getSupplier('', query)" style='width: 100%;'
							@change="getDrawer('add', 'clear')">
							<el-option v-for="item in options.supplier_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发票抬头" prop="drawer_id">
						<el-select v-model="addForm.drawer_id" clearable placeholder="请选择发票抬头" style='width: 100%;'>
							<el-option v-for="item in options.drawer_id_options" :key="item.value"
								:label="item.label + '【' + item.bank.bank_branch_txt + '/' + item.bank.invoice_type + item.bank.invoice_rate + '%】'"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发票类目" prop="invoice_info">
						<el-select v-model="addForm.invoice_info" clearable placeholder="请选择发票类目" filterable style='width: 100%;'>
							<el-option v-for="item in options.invoice_info_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发票号" prop="invoice_code">
						<el-input v-model="addForm.invoice_code" placeholder="请填写发票号" clearable maxlength="30"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="票面金额" prop="invoice_cost">
						<el-input v-model="addForm.invoice_cost" placeholder="请填写票面金额" clearable></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addInvoiceentry" :size='size' :disabled="addSubmitDisabled">提交</el-button>
					<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--编辑发票录入-->
		<el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="40%">
			<el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>编辑发票录入</span>
						<i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="开票方">
						<el-radio-group v-model="editForm.type" @input="changeSUpplier()">
							<el-radio :label="1">供应商</el-radio>
							<el-radio :label="3">平台</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="开票方" prop="supplier_id">
						<el-select v-model="editForm.supplier_id" placeholder="请选择收票方" clearable filterable remote reserve-keyword
							:remote-method="(query) => getSupplier('', query)" style='width: 100%;'
							@change="getDrawer('edit', 'clear')">
							<el-option v-for="item in options.supplier_id_options" :key="item.value"
								:label="item.label + '【' + item.code + '】'" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发票抬头" prop="drawer_id">
						<el-select v-model="editForm.drawer_id" clearable placeholder="请选择发票抬头" style='width: 100%;'>
							<el-option v-for="item in options.drawer_id_options" :key="item.value"
								:label="item.label + '【' + item.bank.bank_branch_txt + '/' + item.bank.invoice_type + item.bank.invoice_rate + '%】'"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发票类目" prop="invoice_info">
						<el-select v-model="editForm.invoice_info" clearable filterable placeholder="请选择发票类目" style='width: 100%;'>
							<el-option v-for="item in options.invoice_info_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发票号" prop="invoice_code">
						<el-input v-model="editForm.invoice_code" placeholder="请填写发票号" clearable></el-input>
					</el-form-item>
					<el-form-item label="票面金额" prop="invoice_cost">
						<el-input v-model="editForm.invoice_cost" placeholder="请填写票面金额" clearable></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="handleTableEdit" :size='size' :disabled="editSubmitDisabled">提交</el-button>
					<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!-- 红冲弹窗 -->
		<el-dialog title="红冲申请" :visible.sync="redDialogVisible" width="400px" :close-on-click-modal="false"
			@close="resetRedForm">
			<el-form :model="redForm" :rules="redRules" :size="size" ref="redForm" label-width="80px">
				<template v-if="redForm.type == 'confirm'">
					<span v-html="redForm.txt_info"></span>
					<el-divider></el-divider>
					<el-form-item label="红冲票号" prop="invoice_number">
						<el-input v-model="redForm.invoice_number" placeholder="请输入发票号" clearable></el-input>
					</el-form-item>
				</template>

				<el-form-item label="票面金额" prop="invoice_amount" v-if="redForm.type == 'submit'">
					<el-input v-model="redForm.invoice_amount" placeholder="请输入票面金额（支持两位小数）" clearable>
						<template slot="append">元</template>
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="redDialogVisible = false" :size="size">取消</el-button>
				<el-button type="primary" @click="submitRedInvoice('redForm')" :size="size">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		// 自定义金额校验规则
		const validateAmount = (rule, value, callback) => {
			if (!value && value !== 0) {
				callback(new Error('请输入票面金额'));
				return;
			}
			const amountRegex = /^\d+(\.\d{1,2})?$/;
			if (!amountRegex.test(value)) {
				callback(new Error('金额格式不正确，请输入数字（支持两位小数）'));
				return;
			}
			const amountNum = parseFloat(value);
			if (amountNum <= 0) {
				callback(new Error('金额必须大于0'));
				return;
			}
			callback();
		}
		return {
			// 红冲弹窗
			tableKey: 0,
			redDialogVisible: false,
			redForm: {
				id: '',
				type: '',
				invoice_number: '',
				invoice_amount: '',
				txt_info: ''
			},
			redRules: {
				invoice_number: [
					{ required: true, message: '请输入发票号', trigger: 'blur' },
					{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
				],
				invoice_amount: [
					{ required: true, validator: validateAmount, trigger: 'blur' }
				]
			},
			dialogVisible: false,
			addFormVisiable: false,
			editFormVisiable: false,
			addSubmitDisabled: false,
			editSubmitDisabled: false,
			checkSkVisiable: false,
			loading: true,
			activeName: 'first',
			size: 'mini',
			form: {
				remark: '',
				cost: '',
				drawer_id_txt: '',
				invoice_rate: '',
				invoice_info_txt: '',
				invoice_cost: '',
				used_cost: ''
			},
			options: {
				id_red_options: [
					{
						value: 1,
						label: '红冲票'
					}, {
						value: 2,
						label: '正式票'
					},
				],
				hong_que_options: [
					{
						value: 1,
						label: '正常'
					}, {
						value: 2,
						label: '待确认'
					}
				],
				hong_options: [
					{
						value: 1,
						label: '未红冲'
					}, {
						value: 2,
						label: '部分红冲'
					}, {
						value: 3,
						label: '已红冲'
					}
				],
				status_options: [
					{
						value: 1,
						label: '未关联'
					}, {
						value: 2,
						label: '部分关联'
					}, {
						value: 3,
						label: '全部关联'
					}
				],
				invoice_type_options: [
					{
						value: 1,
						label: '普票'
					}, {
						value: 2,
						label: '专票'
					}, {
						value: 3,
						label: '形式发票'
					}
				],
				invoice_status_options: [
					{
						value: 1,
						label: '收票'
					}, {
						value: 2,
						label: '开票'
					}
				],
				invoice_info_options: [],
				supplier_id_options: [],//实际结算方
				drawer_id_options: []//发票抬头
			},
			searchForm: {
				invoice_code: '',
				drawer_id: '',
				invoice_status: '',
				is_red: '',
				c_status: '',
				is_red_status: '',
				invoice_type: '',
				invoice_info: '',
				status: '',
				create_time: ''
			},
			resetSearch: {
				invoice_code: '',
				drawer_id: '',
				invoice_status: '',
				is_red: '',
				c_status: '',
				is_red_status: '',
				invoice_type: '',
				invoice_info: '',
				status: '',
				create_time: ''
			},
			addForm: {
				type: 1,
				supplier_id: '',
				drawer_id: '',
				invoice_info: '',
				invoice_code: '',
				invoice_cost: ''
			},
			editForm: {
				type: 1,
				supplier_id: '',
				drawer_id: '',
				invoice_info: '',
				invoice_code: '',
				invoice_cost: ''
			},
			rules: {
				form: {
					'cost': [
						{ validator: this.validatePass, trigger: 'blur' }
					]
				},
				addForm: {
					'supplier_id': [
						{ required: true, message: '请选择实际结算方', trigger: ['change', 'blur'] }
					],
					'drawer_id': [
						{ required: true, message: '请选择发票抬头', trigger: ['change', 'blur'] }
					],
					'invoice_info': [
						{ required: true, message: '请选择发票类目', trigger: ['change'] }
					],
					'invoice_code': [
						{
							required: true, validator: (rule, value, callback) => {
								const regex = /^(?!.*-.*-)[\d.-]+$/; // 匹配整数或浮点数
								if (!value) {
									callback(new Error('请填写发票号'));
								} else {
									if (!regex.test(value)) {
										callback(new Error('请填写正确的发票号'));
									} else {
										callback();
									}
								}
							}, trigger: ['change', 'blur']
						}
					],
					'invoice_cost': [
						{ required: true, message: '请填写票面金额', trigger: ['change'] }
					]
				},
				editForm: {
					'supplier_id': [
						{ required: true, message: '请选择实际结算方', trigger: ['change', 'blur'] }
					],
					'drawer_id': [
						{ required: true, message: '请选择发票抬头', trigger: ['change', 'blur'] }
					],
					'invoice_info': [
						{ required: true, message: '请选择发票类目', trigger: ['change'] }
					],
					'invoice_code': [
						{
							required: true, validator: (rule, value, callback) => {
								const regex = /^\d+(\.\d+)?$/; // 匹配整数或浮点数
								if (!value) {
									callback(new Error('请填写发票号'));
								} else {
									if (!regex.test(value)) {
										callback(new Error('请填写正确的发票号'));
									} else {
										callback();
									}
								}
							}, trigger: ['change', 'blur']
						}
					],
					'invoice_cost': [
						{ required: true, message: '请填写票面金额', trigger: ['change'] }
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			uploadForm: {
				htfj_list: [],//合同附件
				htfj_files: []
			},
		}
	},
	computed: {
		isSupper: function () {
			return this.info.views.isSupper
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	mounted: function () {
		this.getInvoiceType()
		//this.handleSearch(this.searchForm);
	},
	methods: {
		handleTableQueren (row) {
			const messages = [
				`发票编号: ${row['invoice_code']} | 票面金额: ${row['invoice_cost']}`,
				`申请红充${row.c_cost}元,确认驳回？`,
			]
			const txt_info = messages.join('<br/>')
			this.$confirm(txt_info, '提示', {
				dangerouslyUseHTMLString: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.post('/admin/customers/customer/quereninvoicered', { 'type': 2, 'id': row.id }).then(res => {
					if (res.code === 0) {
						this.$message.success('红冲申请驳回成功');
						this.handleSearch(this.searchForm)
					} else {
						this.$message.error(res.msg);
					}
				})
			});
		},
		addInvoiceCategoryOpen () {
			this.$prompt('请输入发票类目', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPlaceholder: '例:*测试发票类目*测试费',
				inputValidator: (value) => {
					if (!value) {
						return '发票类目不能为空';
					} else if (value.length > 30) {
						return '发票类目不能超过30个字符';
					}
				},
				inputErrorMessage: '发票类目有误'
			}).then(({ value }) => {
				this.$api.post('/admin/customers/customer/iseditcategory', { 'name': value }).then(res => {
					if (res.code === 0) {
						this.getInvoiceType()
						this.$message.success('发票类目添加成功');
					} else {
						this.$message.error(res.msg);
					}
				})
			}).catch(() => {
			});
		},
		getInvoiceType () {
			this.$api.get('/admin/customers/customer/getInvoiceType').then(res => {
				if (res.code === 0) {
					this.options.invoice_info_options = res.data;
				}
			})
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		validatePass: function (rule, value, callback) {
			if (!/^[+]?\d+(\.\d{1,2})?$/.test(value)) {
				// 验证失败，返回错误信息
				callback(new Error('发票金额格式不正确,例:120.35'))
			}
			if (value * 100 > this.form.used_cost) {
				// 验证失败，返回错误信息
				callback(new Error('发票部分关联或全部关联，红冲金额不能大于剩余未关联金额'))
			}
			callback()
		},
		handleSearch: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/customers/customer/getInvoiceentrylist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
					this.tableKey += 1;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		changeSUpplier () {
			this.addForm.supplier_id = ''
			this.editForm.supplier_id = ''
			this.getSupplier()
		},
		//获取供应商列表即实际结算方
		getSupplier (cleartype, query) {
			var map = {}
			if (query) {
				map['query'] = query
			}
			map['type'] = this.editFormVisiable ? this.editForm.type : this.addForm.type
			if (this.editFormVisiable && cleartype == 'clear') {
				this.editForm.supplier_id = ''
				this.editForm.drawer_id = ''
				this.$nextTick(() => {
					this.$refs['editForm'].clearValidate();
				});
			}
			if (this.addFormVisiable) {
				this.addForm.supplier_id = ''
				this.addForm.drawer_id = ''
				this.$nextTick(() => {
					this.$refs['addForm'].clearValidate();
				});
			}
			this.$api.get('/admin/resources/resources/supldwn', map).then(res => {
				if (res.code === 0) {
					this.options.supplier_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取发票抬头
		getDrawer (type, change) {
			let param

			if (type == 'add') {
				this.addForm.drawer_id = ''
				this.options.drawer_id_options = []
			} else if (type == 'edit' && change == 'clear') {
				this.editForm.drawer_id = ''
				this.options.drawer_id_options = []
			}
			if (type == "add") {
				param = { supplier_id: this.addForm.supplier_id }
			} else {
				param = { supplier_id: this.editForm.supplier_id }
			}
			param['type'] = this.editFormVisiable ? this.editForm.type : this.addForm.type
			if ((this.addForm.supplier_id && type == 'add') || (this.editForm.supplier_id && type == 'edit')) {
				this.$api.get('/admin/customers/customer/getresourcesupplier', param).then(res => {
					if (res.code === 0) {
						this.options.drawer_id_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			}
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加合同弹窗
		addInvoiceentryOpen () {
			this.addForm = {
				type: 1,
				supplier_id: '',
				drawer_id: '',
				invoice_info: '',
				invoice_code: '',
				invoice_cost: ''
			}
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.getSupplier()
			this.addFormVisiable = true;
		},
		handleTableShengpi (row) {
			this.$api.post('/admin/customers/customer/confirmsubmitreinvoice', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该发票已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 添加合同
		addInvoiceentry () {
			if (this.addSubmitDisabled) return;
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.addSubmitDisabled = true;
					this.$api.post('/admin/customers/customer/invoiceentry', this.addForm).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '添加成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.addSubmitDisabled = false;
					}).catch(() => {
						this.addSubmitDisabled = false;
					})
				}
			}.bind(this));
		},
		// 打开编辑发票弹窗
		handleTableEditOpen (row) {
			this.editForm = {
				type: '',
				supplier_id: '',
				drawer_id: '',
				invoice_info: '',
				invoice_code: '',
				invoice_cost: ''
			}
			this.$api.get('/admin/customers/customer/getinvoiceentry', { id: row.id }).then(res => {
				if (res.code === 0) {
					//   this.editForm = res.data
					this.editFormVisiable = true;
					this.$set(this, 'editForm', res.data)
					this.getSupplier('add', res.data.supplier_id_txt)
					this.getDrawer('edit', 'keep')


				} else {
					this.$message.error(res.msg);
				}
			})
		},
		// 编辑发票信息
		handleTableEdit () {
			if (this.editSubmitDisabled) return;
			this.$refs['editForm'].validate(function (valid) {
				if (valid) {
					this.editSubmitDisabled = true;
					this.loading = true;
					this.$api.post('/admin/customers/customer/invoiceentryedit', this.editForm).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '发票录入信息修改成功！',
								type: 'success'
							});
							this.editFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false;
						this.editSubmitDisabled = false;
					}).catch(() => {
						this.loading = false;
						this.editSubmitDisabled = false;
					})
				}
			}.bind(this));
		},
		valueInit (value) {

		},
		submitInvoice (formName) {
			this.loading = true;
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/customers/customer/confirmsubmitreinvoice', this.form).then(res => {
						if (res.code === 0) {
							var data = this.tableData.data;
							data.forEach(function (item, index) {
								if (this.form.id == item.id) {
									this.$set(data[index], 'status_txt', '待审核');
									this.$set(data[index], 'status', 2);
								}
							}.bind(this));
							this.$message({
								showClose: true,
								message: '该发票已进入审批流程，等待审核！',
								type: 'success'
							});
						} else {
							this.$message.error(res.msg);
						}
						this.dialogVisible = false
						this.loading = false
					})
				}
			});


		},
		// 发票红冲
		// 打开红冲弹窗
		handleTableRed (row, type) {
			this.redForm = {
				id: row.id,
				type: type,
				invoice_number: '',
				invoice_amount: '',
				txt_info: ''
			};
			if (type == 'confirm') {
				const messages = `<p>发票编号: <span style="font-weight: bold;color:red;">${row['invoice_code']}</span> | 票面金额: <span style="font-weight: bold;color:red;">${row['invoice_cost']}</span></p><p>
					申请红充<span style="font-weight: bold;color:red;">${row['c_cost']}</span>元,是否确认？</p>`
				this.redForm.txt_info = messages
			}
			this.redDialogVisible = true;
			// 清除表单验证
			this.$nextTick(() => {
				if (this.$refs.redForm) {
					this.$refs.redForm.clearValidate();
				}
			});
		},

		// 重置表单
		resetRedForm () {
			this.redForm = {
				id: '',
				type: '',
				invoice_number: '',
				invoice_amount: '',
				txt_info: ''
			};
			if (this.$refs.redForm) {
				this.$refs.redForm.clearValidate();
			}
		},
		// 提交红冲
		submitRedInvoice (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.redForm.type == 'submit') {
						this.$api.post('/admin/customers/customer/addinvoicered', this.redForm).then(res => {
							if (res.code === 0) {
								this.$message({
									showClose: true,
									message: '红冲申请成功，等待财务部门确认！',
									type: 'success'
								});
								this.redDialogVisible = false;
								// 刷新列表（根据你的实际情况）
								this.handleSearch(this.searchForm)
							} else {
								this.$message.error(res.msg);
							}
						})
					} else {
						this.$api.post('/admin/customers/customer/quereninvoicered', { 'type': 1, 'id': this.redForm.id, 'inovice_code': this.redForm.invoice_number }).then(res => {
							if (res.code === 0) {
								this.$message.success('红冲申请成功');
								this.redDialogVisible = false;
								// 刷新列表（根据你的实际情况）
								this.handleSearch(this.searchForm)
							} else {
								this.$message.error(res.msg);
							}
						})

					}

				}
			})
		},
		// 删除合同
		handleTableDelete (row) {
			// this.dialogVisible = true
			// this.form = {
			// 	id:row.id,
			// 	remark:'',
			// 	cost:Number(row.used_cost/100).toFixed(2),
			// 	drawer_id_txt:row.drawer_id_txt,
			// 	invoice_rate:row.invoice_rate,
			// 	invoice_info_txt:row.invoice_info_txt,
			// 	invoice_cost:row.invoice_cost,
			// 	used_cost:row.used_cost
			// }

			this.$confirm('此操作将为作废编码:' + row.invoice_code + '的发票, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/customers/customer/delinvoiceentry', { id: row.id }).then(res => {
					if (res.code === 0) {
						this.handleSearch(this.searchForm);
						this.$message({
							showClose: true,
							message: '该发票录入已成功作废！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'EntryDetail',
				query: { id: row.id, set_id: 6, type: 'detail' }
			});
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/entryDetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>